<template>
  <div class="container">
    <ul class="buttons">
      <template v-if="data.userType == 'company'">
<li class="button btn1" >
        <router-link to="/system/review/reviewTasksListCompanyAlt">
          <div class="contents">
            <img src="../../assets/document.png" alt="" />
            <p>评价任务填报</p>
          </div>
        </router-link>
      </li>
      <li class="button btn2" >
        <router-link to="/system/userTable/comInfo">
          <div class="contents">
            <img src="../../assets/document.png" alt="" />
            <p>企业基本信息</p>
          </div>
        </router-link>
      </li>
      </template>
      

      <li class="button btn2" v-if="data.userType == 'government'">
        <router-link to="/system/audition/auditionList">
          <div class="contents">
            <img src="../../assets/document.png" alt="" />
            <p>评价审核列表</p>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { reactive, unref, onBeforeUnmount, ref, computed } from "vue-demi";
import { ElMessageBox, ElMessage } from "element-plus";
import api from "../../http/apis";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
export default {
  setup() {
    const router = useRouter();
    const store = useStore();
    const data = reactive({
      userType: computed(() => {
        return store.state.user.userInfo.orgCode ? "company" : "government";
      }),
    });
    //  async function getNotify(){
    //   const {data}=await api.miscApi.getNotifyStatus()
    //   console.info("get notify data",data)
    //   if(data.IsSuccessful){
    //     if(data.ResultData=='false'){
    //       ElMessageBox.alert(data.ResultMsg,'系统提示',{
    //         type:'warning',

    //       })
    //       .then(()=>{
    //       router.push({
    //         path: '/system/documentTraining/indexPage',

    //       });
    //       })
    //     }
    //   }
    //  }
    //  getNotify()
    return {
      data,
    };
  },
};
</script>

<style lang='scss' scoped>
.container {
  display: flex;
  flex-wrap: wrap;
  height: calc(100vh - 60px);
  width: calc(100vw - 180px);
  justify-content: center;
  align-items: center;
  .buttons {
    position: relative;
    top: -4em;
    height: 80%;
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;

    .button {
      //   height: 18em;
      // width: 40em;
      height: 40%;
      width: 40%;
      border-radius: 0.5em;
      position: relative;
      z-index: 1;
      cursor: pointer;
      transition: 0.2s;
      &:hover {
        transform: scale(1.05);
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
      }
      &::after {
        content: "";
        display: block;
        height: 100%;
        width: 100%;
        z-index: 2;
        border-radius: 0.5em;
        background: url("../../assets/Wave-100s-640px.png");
      }
      .contents {
        position: absolute;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        > img {
          height: 60%;
          opacity: 0.6;
          user-select: none;
          cursor: pointer;
        }
        > p {
          margin-left: 0.5em;
          font-size: 4em;
          color: white;
          font-weight: bold;
        }
      }
    }
    .btn1 {
      background: linear-gradient(45deg, #fe869b, #ffd4b0);
    }
    .btn2 {
      background: linear-gradient(-45deg, #fa8852, #febc80);
    }
  }
}
</style>